module.exports = __webpack_public_path__ + "img/2_2.017afc04.png";